// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2yM40","consentsList":"PatientConsents_consentsList__2SNKC","consentsListEmpty":"PatientConsents_consentsListEmpty__3300Q"};